import React, { useEffect, useState } from "react";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import TableCustom from "../../../../components/table/tableCustom";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import { icons } from "../../../../assets/icons/icons";
import { InputValueNewClassRoom } from "../../../../domains/class-room";
import ModalSearchAdvisor from "./ModalSearchAdvisor";
import {
  alertActive,
} from "../../../../components/alert/swal";
import { useDispatch } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
type IFormAddNewAdvisor = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  actionModalType: string;
  setActionModalType: (value: string) => void;

  inputValue: InputValueNewClassRoom;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueNewClassRoom>>;
  isViewOnly: boolean;
  isCanEdit?: boolean;
};

const FormAddNewAdvisor: React.FC<IFormAddNewAdvisor> = ({
  isOpenModal,
  setIsOpenModal,
  actionModalType,
  setActionModalType,
  inputValue,
  setInputValue,
  isViewOnly,
  isCanEdit,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [isOpenDetail, setIsOpenDetail] = useState<boolean>(true);
  const [singleAdvisor, setSingleAdvisor] = useState<any>({});

  useEffect(() => {
    if (inputValue.advisor && inputValue.advisor.length > 0)
      setDataAdvisor(inputValue.advisor);
  }, [inputValue.advisor]);

  const handleDelete = async (id: number) => {
    if (id) {
      alertActive(
        t("ลบอาจารย์ที่ปรึกษา"),
        t("ท่านต้องการลบอาจารย์ที่ปรึกษา ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          const updatedAdvisors = inputValue.advisor.filter(
            (advisor) => parseInt(advisor.employee_id.toString()) !== id
          );

          setInputValue({ ...inputValue, advisor: updatedAdvisors });
          setDataAdvisor(updatedAdvisors);

          // dispatch(setLoading());
          // await advisorTypeApi
          //   .deleteAdvisorType(+id)
          //   .then((res) => {
          //     if (res.status < 300) {
          //       alertSuccess(
          //         "ลบอาจารย์ที่ปรึกษา เรียบร้อย",
          //         undefined,
          //         undefined,
          //         () => {
          //           setIsOpenModal(false);
          //         }
          //       );
          //     }
          //   })
          //   .catch(() => {
          //     alertError("อาจารย์ที่ปรึกษา ไม่สำเร็จ");
          //   })
          //   .finally(() => {
          //     dispatch(unsetLoading());
          //   });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "advisor_name",
      width: 70,
      disablePadding: true,
      align: "start",
      label: t("ชื่อ - นามสกุล"),
    },
    {
      id: "type",
      width: 30,
      disablePadding: true,
      align: "start",
      label: t("ประเภท"),
    },
    {
      id: "button",
      disablePadding: true,
      align: "right",
      width: 40,
      class: matches && dataAdvisor?.length > 0 && isCanEdit,
      label: !isViewOnly && (
        <ButtonPrimary
          onClick={() => {
            setIsOpenModal(true);
            setActionModalType("create");
          }}
          btnProps={{
            // bg: "white",
            text: "black",
          }}
          mode="add_request"
          buttonName={t("เพิ่ม")}
          disabled={!isCanEdit}
        />
      ),
    },
    // {
    //   id: "action",
    //   disablePadding: true,
    //   align: "center",
    //   width: 10,
    //   label: ""
    //   // label: (
    //   //   <IconButton onClick={() => setIsOpenDetail(!isOpenDetail)}>
    //   //     {isOpenDetail ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
    //   //   </IconButton>
    //   // ),
    // },
  ];

  const renderData = (objData: any, no: any) => {
    no = 1;
    const { employee_id, employee_name, advisor_type_name } =
      objData;

    const objRenderData = {
      key: employee_id,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: employee_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: t(advisor_type_name),
        },
        {
          option: "COMPONENT",
          align: "start",
          class: matches,
          component: !isViewOnly && isCanEdit && (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "flex-end",
              }}
            >
              <img
                onClick={() => {
                  setSingleAdvisor(objData);
                  setIsOpenModal(true);
                  setActionModalType("view");
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  setSingleAdvisor(objData);
                  setIsOpenModal(true);
                  setActionModalType("update");
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDelete(employee_id);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <>
      <ModalSearchAdvisor
        setIsOpenModal={(isOpen: boolean) => setIsOpenModal(isOpen)}
        isOpenModal={isOpenModal}
        inputValue={inputValue}
        setInputValue={setInputValue}
        actionType={actionModalType}
        singleAdvisor={singleAdvisor}
        dataAdvisor={dataAdvisor}
      />

      <TableCustom
        tableMinWidth={500}
        tableFixedWidth
        customScroll
        page={1}
        pageLimit={100}
        sortBy={"no"}
        sortType={"ASC"}
        headCells={headCells}
        rowCount={dataAdvisor.length}
        rowsData={
          dataAdvisor &&
          dataAdvisor
            .filter((raw: any) => raw?.id_class_room_employee !== null)
            .map((data: any, i: any) => {
              return renderData(data, i);
            })
        }
        onSort={() => { }}
        setPageLimit={(value: number) => { }}
        setPage={(value: number) => { }}
        hidePagination={true}
      />
    </>
  );
};

export default FormAddNewAdvisor;
